/* import __COLOCATED_TEMPLATE__ from './default-empty-chart.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();